import * as stylex from '@stylexjs/stylex';
import { borderRadius, color, spacer } from '@figma/fpl-tokens/tokens.stylex';

export const styles = stylex.create({
  resizableTextInput: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    resize: 'vertical',
    overflow: 'auto',
    minHeight: `calc(3lh + 2 * ${spacer.spacer1})`,
  },
  inputRow: {
    width: '100%',
  },
  invalidText: {
    outline: `1px solid ${color.borderDangerStrong}`,
    outlineOffset: -1,
  },
  inputError: {
    marginTop: { default: spacer.spacer2, ':first-child': 0 },
  },
  label: {
    minWidth: 0,
  },
  headerActions: {
    marginLeft: 'auto',
    flexShrink: 0,
  },
  sliderWrapper: {
    minWidth: 0,
    display: 'grid',
    alignItems: 'center',
    padding: `0 ${spacer.spacer1}`,
    backgroundColor: {
      default: color.bgSecondary,
      ':has([aria-disabled="true"])': color.bg,
    },
    borderRadius: `${borderRadius.medium} 0 0 ${borderRadius.medium}`,
    outline: {
      default: null,
      ':has([aria-disabled="true"])': `1px solid ${color.borderDisabled}`,
    },
    outlineOffset: {
      default: null,
      ':has([aria-disabled="true"])': -1,
    },
  },
  fixedSeedGroup: {
    flex: '1 1 0',
    minWidth: 0,
    backgroundColor: color.bgSecondary,
    borderRadius: borderRadius.medium,
  },
  fixedSeedGroupDisabled: {
    backgroundColor: color.bg,
  },
  seedRefreshIcon: {
    '--fpl-icon-color': color.iconSecondary,
  },
});
